import React, { useEffect, useState } from 'react';
import axios from '../api';
import { Table, Button, Badge, Spinner, Card, Image } from 'react-bootstrap';

function Restock() {
  const [alerts, setAlerts] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchAlerts = async () => {
    try {
      const res = await axios.get('/restock');
      setAlerts(res.data);
    } catch (err) {
      console.error('Error fetching restock alerts:', err);
    } finally {
      setLoading(false);
    }
  };

  const markAsRead = async (sku) => {
    try {
      await axios.post('/restock/read', { sku });
      setAlerts(prev => prev.filter(a => a.sku !== sku));
    } catch (err) {
      console.error('Error marking as read:', err);
    }
  };

  useEffect(() => {
    fetchAlerts();
    const interval = setInterval(fetchAlerts, 30000);
    return () => clearInterval(interval);
  }, []);

  if (loading) {
    return <Spinner animation="border" />;
  }

  return (
    <div>
      <h2 className="mb-3">🚨 Restock Alerts</h2>

      <Card>
        <Card.Body>
          {alerts.length === 0 ? (
            <p>No low stock items</p>
          ) : (
            <Table striped bordered hover responsive>
              <thead>
                <tr>
                  <th style={{ width: '70px' }}>Image</th>
                  <th>SKU</th>
                  <th>Product</th>
                  <th>Stock</th>
                  <th>Threshold</th>
                  <th>Price</th>
                  <th>Cost</th>
                  <th>Profit</th>
                  <th>ROI</th>
                  <th>Action</th>
                </tr>
              </thead>
              <tbody>
                {alerts.map(alert => {
                  const price = Number(alert.price || 0);
                  const cost = Number(alert.cost_price || 0);

                  const profit =
                    alert.profit !== undefined
                      ? Number(alert.profit)
                      : price - cost;

                  const roi =
                    alert.roi !== undefined
                      ? Number(alert.roi)
                      : cost > 0
                      ? ((profit / cost) * 100)
                      : 0;

                  return (
                    <tr key={alert.sku}>
                      {/* IMAGE */}
                      <td className="text-center align-middle">
                        {alert.image ? (
                          <Image
                            src={alert.image}
                            alt={alert.title}
                            style={{
                              width: '50px',
                              height: '50px',
                              objectFit: 'cover',
                              borderRadius: '6px'
                            }}
                          />
                        ) : (
                          <div
                            style={{
                              width: 50,
                              height: 50,
                              background: '#eee',
                              borderRadius: 6
                            }}
                          />
                        )}
                      </td>

                      <td className="align-middle">{alert.sku}</td>

                      <td className="align-middle">
                        <strong>{alert.title}</strong>
                      </td>

                      <td className="align-middle">
                        <Badge bg="danger">{alert.current_stock}</Badge>
                      </td>

                      <td className="align-middle">{alert.threshold}</td>

                      {/* PRICE */}
                      <td className="align-middle">
                        ${price.toFixed(2)}
                      </td>

                      {/* COST */}
                      <td className="align-middle">
                        ${cost.toFixed(2)}
                      </td>

                      {/* PROFIT */}
                      <td className="align-middle">
                        <span style={{ color: profit >= 0 ? 'green' : 'red' }}>
                          ${profit.toFixed(2)}
                        </span>
                      </td>

                      {/* ROI */}
                      <td className="align-middle">
                        <span style={{ color: roi >= 0 ? 'green' : 'red' }}>
                          {roi.toFixed(1)}%
                        </span>
                      </td>

                      <td className="align-middle">
                        <Button
                          size="sm"
                          variant="success"
                          onClick={() => markAsRead(alert.sku)}
                        >
                          Mark Read
                        </Button>
                      </td>
                    </tr>
                  );
                })}
              </tbody>
            </Table>
          )}
        </Card.Body>
      </Card>
    </div>
  );
}

export default Restock;